import { render, staticRenderFns } from "./bsHeader.vue?vue&type=template&id=087c3fd6&scoped=true&"
import script from "./bsHeader.vue?vue&type=script&lang=js&"
export * from "./bsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c3fd6",
  null
  
)

export default component.exports